import React from 'react';

import './toolbar-group.scss';

const ToolbarGroup = ({ children }) => {
  return (
    <div
      className="toolbar-group"
    >
      {children}
    </div>
  );
};

export default ToolbarGroup;
